 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		5: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		5: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"commons","1":"9901bd57cdd0d82185ac9cc1c5322181260ab32e","2":"330b0d30e02362d7500d5a38651f062ae038c75b","3":"framework","4":"9daaf0314c6d6f07e317e38947f76bda42b93467","7":"component---gatsby-theme-husky-src-pages-404-tsx","8":"component---gatsby-theme-husky-src-templates-article-page-article-page-tsx","9":"component---gatsby-theme-husky-src-templates-contact-us-page-contact-us-page-tsx","10":"component---gatsby-theme-husky-src-templates-product-detail-page-product-detail-page-tsx","11":"component---gatsby-theme-husky-src-templates-search-results-page-search-results-page-tsx","12":"component---gatsby-theme-husky-src-templates-simple-contest-page-simple-contest-page-tsx","13":"component---gatsby-theme-husky-src-templates-sitemap-page-sitemap-page-tsx","14":"component---gatsby-theme-husky-src-templates-tips-and-tricks-page-tips-and-tricks-page-tsx","15":"component---gatsby-theme-husky-src-templates-tips-and-tricks-videos-page-tips-and-tricks-videos-page-tsx","16":"component---gatsby-theme-husky-src-templates-tips-for-you-page-tips-for-you-page-tsx","17":"component---src-gatsby-theme-husky-templates-home-page-home-page-tsx","18":"component---src-gatsby-theme-husky-templates-lds-page-index-ts","19":"component---src-gatsby-theme-husky-templates-products-list-page-products-list-page-tsx","20":"components-PromoPanel","21":"components-SignUpBanner"}[chunkId]||chunkId) + "-" + {"0":"e0b516679dadc80838e2","1":"101be97c47beef8b674d","2":"aeee795cc3a165f92e44","3":"9e9f65e8a014192ff961","4":"e24f8dde4a590834434b","7":"6e93efb080eedd03dad4","8":"513ccccdc9eec552c90d","9":"a026e1bcc4d4eb2ab11d","10":"f303697d09bf4ee1fc48","11":"a253030b4de7ce4757ce","12":"4a147391c59350c7280d","13":"aaf090d94b68c94c61d2","14":"ae001e829b61875adf70","15":"03ac41393b06d9aa6eb9","16":"30464a410c048a37a084","17":"76906a1893567c8d8f2a","18":"61fd603f9380c5751adf","19":"43e8f70d20aa6df156b6","20":"85b0c2dd555a9c97db80","21":"6fbc04597d36fae5c702"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"0":1,"7":1,"8":1,"9":1,"10":1,"11":1,"12":1,"13":1,"14":1,"15":1,"16":1,"17":1,"18":1,"19":1,"20":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"commons","1":"9901bd57cdd0d82185ac9cc1c5322181260ab32e","2":"330b0d30e02362d7500d5a38651f062ae038c75b","3":"framework","4":"9daaf0314c6d6f07e317e38947f76bda42b93467","7":"component---gatsby-theme-husky-src-pages-404-tsx","8":"component---gatsby-theme-husky-src-templates-article-page-article-page-tsx","9":"component---gatsby-theme-husky-src-templates-contact-us-page-contact-us-page-tsx","10":"component---gatsby-theme-husky-src-templates-product-detail-page-product-detail-page-tsx","11":"component---gatsby-theme-husky-src-templates-search-results-page-search-results-page-tsx","12":"component---gatsby-theme-husky-src-templates-simple-contest-page-simple-contest-page-tsx","13":"component---gatsby-theme-husky-src-templates-sitemap-page-sitemap-page-tsx","14":"component---gatsby-theme-husky-src-templates-tips-and-tricks-page-tips-and-tricks-page-tsx","15":"component---gatsby-theme-husky-src-templates-tips-and-tricks-videos-page-tips-and-tricks-videos-page-tsx","16":"component---gatsby-theme-husky-src-templates-tips-for-you-page-tips-for-you-page-tsx","17":"component---src-gatsby-theme-husky-templates-home-page-home-page-tsx","18":"component---src-gatsby-theme-husky-templates-lds-page-index-ts","19":"component---src-gatsby-theme-husky-templates-products-list-page-products-list-page-tsx","20":"components-PromoPanel","21":"components-SignUpBanner"}[chunkId]||chunkId) + "." + {"0":"9250b93f12dd05857cbe","1":"31d6cfe0d16ae931b73c","2":"31d6cfe0d16ae931b73c","3":"31d6cfe0d16ae931b73c","4":"31d6cfe0d16ae931b73c","7":"87e3d04de5c4dd9931de","8":"083794317c66bd8f0b49","9":"deac05aaad344d0813c6","10":"cd48018351a49f9070f2","11":"21a66aaa402ae65d8f24","12":"ac133784f80a6fee16c2","13":"70b6722104e9cb2056e3","14":"2ddfbd94de42a5e4ffb1","15":"6f9673064b1d1d17da9b","16":"fda866bdfccb90a68de5","17":"a612fe48f8dc0253d1a3","18":"dd74db40818b89b52624","19":"0ee70020cb33b86400fb","20":"2f0b3134f1f42b9dc94f","21":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["__LOADABLE_LOADED_CHUNKS__"] = window["__LOADABLE_LOADED_CHUNKS__"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
